/* eslint-disable no-unused-vars */
import React from "react";
import { MDBContainer, MDBRow, MDBCol, MDBFormInline, MDBIcon } from "mdbreact";
import styles from "./style.module.scss";
import Collapse from "./components/Collapse";
import { client } from "~/utils/medproSDK";
import { uniqueId } from "lodash-es";
import AppID from "~/utils/partner";

class SelectedVacxinNhidonghcm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listVacxin: []
    };
  }

  componentDidMount = async () => {
    try {
      const response = await client.getInfoVaccineService(
        { patientId: "9d80694548b8448b85c80fa477f87ccf" },
        { partnerid: "nhidongtp" || AppID }
      );
      this.setState({
        listVacxin: response.data
      });
    } catch (error) {
      console.error(error);
    }
  };

  render() {
    const { listVacxin } = this.state;
    console.log("list", listVacxin);
    return (
      <div style={{ marginTop: "calc(-7vh)" }}>
        <MDBContainer className={styles.container}>
          <MDBRow className={styles.rowHeader}>
            <div className={styles.input}>
              <MDBIcon icon="search" />
              <input placeholder="Tìm nhanh tên nhóm bệnh viện" />
            </div>
          </MDBRow>
          <MDBRow className={styles.rowContent}>
            {listVacxin.map(item => {
              return (
                <MDBCol key={uniqueId()} xl={12} className={styles.colCalendar}>
                  <h4>{item?.key}</h4>
                  <Collapse
                    data={
                      item?.key !== "Tiêm chủng theo gói"
                        ? item?.list
                        : item?.ageList
                    }
                  />
                </MDBCol>
              );
            })}
          </MDBRow>
        </MDBContainer>
      </div>
    );
  }
}
export default SelectedVacxinNhidonghcm;
